import React from 'react';
import Home from './components/Home'
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';

export default function App() {
  function Footer() {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        <Link color="inherit" href="https://www.in.gov/fssa/">
          About FSSA
        </Link> 
        {' | '}       
        <Link color="inherit" href="https://www.in.gov/core/privacy.html">
          Privacy Policy
        </Link>
        {' | '}       
        <Link color="inherit" href="https://www.in.gov/core/terms_of_use.html">
          Terms of Use
        </Link>
      </Typography>
    );
  }
  
  return (
  <React.Fragment>
    <AppBar
      position="absolute"
      color="primary"
      elevation={0}
      sx={{
        position: 'relative',
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
      }}
      >
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
            <img src="/Indiana_Logo.png" width="165" height="35" className="d-inline-block align-top" alt="Indiana family and social services administration" />
          </Typography>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
          <Home />
        </Paper>
        <Footer />
      </Container>  
  </React.Fragment>    
  );
}